/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_sig_pen_width = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pen width`)
};

const es_sig_pen_width = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ancho del lápiz`)
};

const de_sig_pen_width = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stiftbreite`)
};

const nl_sig_pen_width = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penbreedte`)
};

const fr_sig_pen_width = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Largeur du trait`)
};

const it_sig_pen_width = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Larghezza penna`)
};

const pt_br2_sig_pen_width = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Largura da caneta`)
};

const pt_sig_pen_width = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Largura da caneta`)
};

const ja_sig_pen_width = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ペン幅`)
};

const zh_sig_pen_width = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`笔宽`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const sig_pen_width = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.sig_pen_width(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("sig_pen_width", locale)
	if (locale === "en") return en_sig_pen_width(inputs)
	if (locale === "es") return es_sig_pen_width(inputs)
	if (locale === "de") return de_sig_pen_width(inputs)
	if (locale === "nl") return nl_sig_pen_width(inputs)
	if (locale === "fr") return fr_sig_pen_width(inputs)
	if (locale === "it") return it_sig_pen_width(inputs)
	if (locale === "pt-BR") return pt_br2_sig_pen_width(inputs)
	if (locale === "pt") return pt_sig_pen_width(inputs)
	if (locale === "ja") return ja_sig_pen_width(inputs)
	return zh_sig_pen_width(inputs)
};